module.exports = __webpack_public_path__ + "img/DSC_5157.56b0553c.jpg";